import {
  DELETE_FILTER_EMISSION,
  SET_FILTER_EMISSION,
} from '@/store/redux/actions/pages/pcp';
import { IReduxActionProps } from '@/store/redux/Utils';

import { RESET_FILTER_EMISSION } from './../../../../../actions/pages/pcp/filters/emission/index';

export interface EmissionFilterStateProps {
  emissionClass?: string | null;
  emissionSticker?: string[];
  co2Efficiency?: string | null;
  minCo2Emission?: number | null;
  maxCo2Emission?: number | null;
  particleFilter?: boolean;
}

export const InitialEmissionFilterState: EmissionFilterStateProps = {
  emissionClass: null,
  emissionSticker: [],
  co2Efficiency: null,
  minCo2Emission: null,
  maxCo2Emission: null,
  particleFilter: false,
};

const EmissionFilterState = (
  state: EmissionFilterStateProps = InitialEmissionFilterState,
  action: IReduxActionProps
) => {
  const value = action.payload as EmissionFilterStateProps;
  switch (action.type) {
    case SET_FILTER_EMISSION: {
      return {
        ...state,
        ...value,
      };
    }
    case DELETE_FILTER_EMISSION: {
      const emissionPayloadKey: keyof EmissionFilterStateProps =
        (action.payload?.emissionClass && 'emissionClass') ||
        (action.payload?.emissionSticker && 'emissionSticker') ||
        (action.payload?.co2Efficiency && 'co2Efficiency') ||
        (action.payload?.minCo2Emission && 'minCo2Emission') ||
        (action.payload?.maxCo2Emission && 'maxCo2Emission') ||
        (action.payload?.particleFilter && 'particleFilter');

      const emissionPayloadValue = action.payload?.emissionSticker;
      let emissionValues;

      if (emissionPayloadKey === 'emissionSticker') {
        const index =
          state[emissionPayloadKey] &&
          state[emissionPayloadKey]?.indexOf(emissionPayloadValue);

        if (index)
          // Check for undefined
          emissionValues = [
            ...(state[emissionPayloadKey]?.slice(0, index) ?? []),
            ...(state[emissionPayloadKey]?.slice(index + 1) ?? []),
          ];
      } else {
        emissionValues = null;
      }

      return {
        ...state,
        [emissionPayloadKey]: emissionValues,
      };
    }
    case RESET_FILTER_EMISSION:
      return InitialEmissionFilterState;
    default:
      return state;
  }
};

export default EmissionFilterState;
